import { useLoaderData } from '@remix-run/react';

const useTypedLoaderData = <T>() => {
  const loaderData = useLoaderData();

  return loaderData as T;
};

export default useTypedLoaderData;
